export default __webpack_public_path__ + "static/polotheme-cover-5ecb46edae7f44071c8c7eb5973e758e.png";